import React from 'react';
import '../css/Autor.css';

const Autor = () => {

  return (
    <div className='container-autor'>
      <img className='img-autor' src="ok.jpg" alt="autor" />
      <div className='info-autor'>
        <h3 >Por Ulisses Oliveira </h3>
        <p >Professor, Diretor Comercial e Gerente de Produtos de Inovação</p>
      </div>
    </div>

  )

};
export default Autor;
